import React from 'react';
import { CreditCard, PenTool, Plug, Search, HelpCircle, MapPin, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const QuickServicesLanding = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const services = [
    {
      title: t("Pay Bill"),
      description: t("Pay outstanding utility bills quickly."),
      icon: <CreditCard className="w-4 h-4" />,
      colorClass: "text-blue-600",
      bgClass: "bg-blue-50",
      path: "/guest/pay-bill"
    },
    {
      title: t("Request Service"),
      description: t("Raise repair or maintenance requests."),
      icon: <PenTool className="w-4 h-4" />,
      colorClass: "text-orange-500",
      bgClass: "bg-orange-50",
      path: "/guest/service-request"
    },
    {
      title: t("New Connection"),
      description: t("Apply for a new water or sewer connection."),
      icon: <Plug className="w-4 h-4" />,
      colorClass: "text-green-600",
      bgClass: "bg-green-50",
      path: "/guest/nsc"
    },
    {
      title: t("Check Application Status"),
      description: t("Track your new connection application."),
      icon: <Search className="w-4 h-4" />,
      colorClass: "text-teal-600",
      bgClass: "bg-teal-50",
      path: "/guest/application-status"
    },
    {
      title: t("View FAQs"),
      description: t("Answers to common utility questions."),
      icon: <HelpCircle className="w-4 h-4" />,
      colorClass: "text-purple-600",
      bgClass: "bg-purple-50",
      path: "/guest/info-center?tab=faqs"
    },
    {
      title: t("Nearby Service Centers"),
      description: t("Find office locations and contact details."),
      icon: <MapPin className="w-4 h-4" />,
      colorClass: "text-cyan-600",
      bgClass: "bg-cyan-50",
      path: "/guest/info-center?tab=offices"
    }
  ];

  return (
    <div className="w-full min-h-full bg-[#f8f9fa] p-6 lg:p-8 flex flex-col justify-center items-center">
      <div className="w-full max-w-3xl">
        <h2 className="text-2xl font-bold text-gray-900 mb-1">{t("Quick Services")}</h2>
        <p className="text-gray-500 text-sm mb-6">{t("No account needed — get started right away")}</p>

        <div className="grid grid-cols-3 gap-3 lg:gap-4">
          {services.map((service, index) => (
            <div 
              key={index} 
              onClick={() => service.path && navigate(service.path)}
              className="bg-white rounded-2xl p-4 border border-gray-100 shadow-sm hover:shadow-md transition-shadow cursor-pointer group flex flex-col min-h-[140px]"
            >
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center mb-3 ${service.bgClass} ${service.colorClass}`}>
                {service.icon}
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-1">{service.title}</h3>
              <p className="text-xs text-gray-500 mb-auto leading-snug">{service.description}</p>
              
              <div className={`flex items-center text-xs font-semibold ${service.colorClass} group-hover:underline mt-3`}>
                {t("Go")} <ArrowRight className="w-3.5 h-3.5 ml-1" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};